module.exports = __webpack_public_path__ + "src/assets/img/antenna_module.a5e80c1c.png";